const useDescuentoStore = defineStore("descuento", () => {
  // state
  const descuento = ref({
    id: null,
    porcentaje: 10, // 10 % por default
    vencible: false,
    fecha_vencimiento: null,
    activo: true,
  });

  const descuentos = ref([]);

  // getters

  const draft = computed(() => clone(descuento.value));

  // mutations

  const setDescuento = (payload) => {
    descuento.value = payload;
  };

  const clear = () => {
    descuento.value = {
      id: null,
      porcentaje: 10,
      vencible: false,
      fecha_vencimiento: null,
      activo: true,
    };
  };

  const setDescuentos = (payload) => (descuentos.value = payload);

  // actions
  const fetch = (descuento_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/descuentos/${descuento_id}/fetch-data`)
        .then(({ data }) => {
          setDescuento(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/descuentos/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .put(`/api/descuentos/${datos.id}`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/descuentos`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (descuento_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/descuentos/${descuento_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchListSelect = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/descuentos/get-list-select`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  return {
    descuento,
    draft,
    setDescuento,
    setDescuentos,
    fetch,
    clear,
    fetchData,
    guardar,
    eliminar,
    fetchListSelect,
  };
});

export default useDescuentoStore;
